window.addEventListener('DOMContentLoaded', function () {
  // const popupBuy = document.querySelector('.popup-buy');
  // if (!popupBuy) return false;

  // initPopupBuy();

  // window.addEventListener('scroll', initPopupBuy);

  // const popupBuyCloseBtn = document.querySelector('.popup-buy__close');
  // popupBuyCloseBtn.addEventListener('click', function () {
  //   hidePopupBuy();
  //   window.removeEventListener("scroll", initPopupBuy);
  // });

  // function initPopupBuy () {
  //   const scroll = window.pageYOffset;
  //   const productPosition = document.querySelector('.detail-product__controls').getBoundingClientRect().bottom + scroll;
  //   const footerPosition = document.querySelector('.footer').getBoundingClientRect().top + scroll - window.innerHeight;

  //   if (scroll > productPosition && scroll < footerPosition) {
  //     showPopupBuy();
  //   } else {
  //     hidePopupBuy();
  //   }
  // }

  // function showPopupBuy () {
  //   popupBuy.classList.add('show');
  //   const popupHeight = popupBuy.offsetHeight;
  //   document.getElementById('arrowTop').style.bottom = popupHeight + 50 + 'px';

  // }

  // function hidePopupBuy () {
  //   popupBuy.classList.remove('show');
  //   document.getElementById('arrowTop').style.bottom = '50px';
  // }
});
